import React, { useEffect } from 'react';
import { Prompt } from 'react-router-dom';
import PropTypes from 'prop-types';
import localization from '../../../localization';

const promptMessage = localization.t('general.promptUnsavedData');

const CustomPrompt = ({ when }) => {
  const dirty = React.useRef(false);
  dirty.current = when;

  useEffect(() => {
    const onBeforeUnload = (e) => {
      if (dirty.current) {
        e.preventDefault();
        e.returnValue = promptMessage;

        return promptMessage;
      }
    };

    window.addEventListener('beforeunload', onBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', onBeforeUnload);
    };
  }, []);

  return (
    <Prompt
      when={when}
      message={promptMessage}
    />
  );
};

CustomPrompt.propTypes = {
  when: PropTypes.bool,
};

export default CustomPrompt;
